import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import { createApiWithPath } from "../../client";
import { FieldType } from "../../types/field-type";

export const fetchAllFieldTypes = async (
  active: boolean = true,
): Promise<FieldType[]> => {
  const { data } = await createApiWithPath("crm").get<{ data: FieldType[] }>(
    `/field-types?active=${active}&limit=1000`,
  );
  return data.data;
};

export const useAllFieldTypes = (
  active: boolean = true,
): QueryObserverBaseResult<FieldType[]> => {
  const { data, ...props } = useQuery(
    queryKeys.allFieldTypes(active),
    () => fetchAllFieldTypes(active),
    {
      onError: (error: any) => {
        console.error("Failed to fetch all field types:", error);
      },
    },
  );
  return { data: data || [], ...props };
};
